export default {
  SET_PAGINATION(state, data) {
    state.pagination = data
  },
  ADD_PDF_TEMPLATE(state, pdfTemplate) {
    state.pdfTemplates.push(pdfTemplate)
  },
  UPDATE_PDF_TEMPLATE(state, pdfTemplate) {
    const index = state.pdfTemplates.findIndex((e) => e.id === pdfTemplate.id)
    Object.assign(state.pdfTemplates[index], pdfTemplate)
  },
  SET_PDF_TEMPLATES(state, pdfTemplates) {
    state.pdfTemplates = pdfTemplates
  },
  REMOVE_PDF_TEMPLATE (state, itemId) {
    const index = state.pdfTemplates.findIndex((u) => u.id === itemId)
    state.pdfTemplates.splice(index, 1)
  }
}

